module.exports = __webpack_public_path__ + "static/media/check_img_form.09aa6c53.png";